import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

/*
 * The API's base path (docs/API.md). Exported because not everything that reaches the API is
 * a fetch: an attachment is downloaded by an <a href>, authenticated by the JWT cookie.
 */
export const API_BASE_URL = '/api/naloge-api/v1'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: API_BASE_URL,
        options: {
            /*
             * The service says why it refused — { error: { code, message } } — and useFetch
             * drops the body of a failed response unless told to keep it. Without this every
             * refusal would read "an error occurred" while the code sat unread.
             */
            updateDataOnError: true,
            beforeFetch({ options }) {
                const headers = new Headers(options.headers)
                const jwt     = appStore.getJWT()

                if (jwt) headers.set('Authorization', `Bearer ${jwt}`)
                options.headers = headers

                return { options }
            },
            async onFetchError(ctx) {
                /*
                 * An expired or revoked session. The login form's own wrong password answers
                 * 401 too, and must stay on the form with its message — so only a session
                 * that exists is thrown away and sent to sign in again.
                 */
                if (ctx.response?.status === 401 && appStore.isLoggedIn()) {
                    const current = router.currentRoute.value

                    appStore.setLogout()
                    await router.push({
                        name:  'login',
                        query: current.name && current.name !== 'login' ? { redirect: current.fullPath } : {},
                    })
                }

                return ctx
            },
        },
    })

    return { fetch }
})
